/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable indent */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */
/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/default-param-last */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-throw-literal */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */

import { http_client } from '../../util/http_client';
import { AnnotationModel } from '../../models/annotation/AnnotationModel';
import { GetUserAnnotationsDto } from './DTOs/GetUserAnnotationsDto';
import { SaveContentAnnotationDto } from './DTOs/SaveContentAnnotationDto';
import { ContentSearchResult } from '../../models/ContentSearchResult';

const ANNOTATIONS_API_URL =
  'https://api2.forumconhecimento.com.br/annotations-api-new/annotations';
// const ANNOTATIONS_API_URL =
//   'http://localhost:5080/annotations-api-new/annotations';

type GetUserAnnotationsResponse = {
  total: number;
  annotations: AnnotationModel[];
  highlight?: { text: string }[];
};

type RawApiResponse = {
  total: number;
  annotations: any[];
  highlight?: { text: string }[];
};

export class AnnotationRequests {
  static async saveAnnotation(dto: SaveContentAnnotationDto) {
    const result = await http_client.post<any>(ANNOTATIONS_API_URL, dto);
    return result.data;
  }

  static async removeAnnotation(annotationId: string) {
    const result = await http_client.delete<any>(
      `${ANNOTATIONS_API_URL}/${annotationId}`
    );
    return result.data;
  }

  static async getUserContentAnnotations(
    contentId: number | string,
    contentType: number
  ): Promise<AnnotationModel[]> {
    const result = await http_client.get<AnnotationModel[]>(
      `${ANNOTATIONS_API_URL}/annotation`,
      {
        params: { contentId, contentType }
      }
    );
    console.log(result.data, ' ::: result.data');
    return result.data;
  }

  static async getUserAnnotations(
    page: number,
    words = '',
    signal?: AbortSignal
  ): Promise<GetUserAnnotationsDto | undefined> {
    if (!page) {
      return undefined;
    }

    const result = await http_client.get<RawApiResponse>(
      `${ANNOTATIONS_API_URL}/list`,
      {
        params: { page, words },
        signal
      }
    );

    const responseData = result.data;
    console.log(responseData, ' ::: responseData');
    const standardizedAnnotations = responseData.annotations.map(
      (rawAnn, index) => {
        let standardizedContent: ContentSearchResult | undefined;
        const rawContent = rawAnn.content;

        if (rawContent) {
          standardizedContent = new ContentSearchResult(
            rawContent.contentType || rawContent.ContentType,
            rawContent.id || rawContent.Id,
            rawContent.title || rawContent.Title,
            rawContent.subTitle || rawContent.SubTitle,
            rawContent.text || rawContent.Text,
            rawContent.tags || rawContent.Tags,
            rawContent.editionId || rawContent.EditionId,
            rawContent.parentId || rawContent.ParentId,
            rawContent.img || rawContent.Img,
            rawContent.author || rawContent.Author,
            rawContent.total || rawContent.Total,
            rawContent.formattedDate || rawContent.FormattedDate,
            rawContent.relevantWords || rawContent.RelevantWords,
            rawContent.articleType || rawContent.ArticleType,
            rawContent.areasInterest || rawContent.AreasInterest,
            rawContent.url || rawContent.Url,
            rawContent.chapterId || rawContent.ChapterId
          );
        }
        const highlightText =
          responseData.highlight &&
          responseData.highlight[index] &&
          responseData.highlight[index].text;
        const annotationText =
          highlightText != null ? highlightText : rawAnn.text;

        return new AnnotationModel(
          rawAnn.id,
          rawAnn.type,
          annotationText,
          rawAnn.json,
          rawAnn.createdAt,
          standardizedContent
        );
      }
    );

    return new GetUserAnnotationsDto(
      responseData.total,
      standardizedAnnotations
    );
  }
}
